import axiosInstance from "../axiosInstance";
import { ApiResponse } from "@/types/apiResponse";

export interface ExamEvent {
  event_id: string;
  name: string;
  start_date: string;
  end_date: string | null;
  kind: "milestone" | "window" | "exam";
  is_countdown_target: boolean;
  /** Dates for an unannounced cycle are projections. Anything false must
   *  be labelled "expected" rather than presented as published fact. */
  is_confirmed: boolean;
  source_url: string | null;
  note: string | null;
}

export interface ExamCycle {
  cycle_id: string;
  name: string;
  organising_institute: string | null;
  /** Admin off switch for the strip above the nav. The countdown figures on
   *  home and syllabus are unaffected — this hides the strip only. */
  show_strip: boolean;
  /** Replaces the generated event sentence in the strip when set. Null means
   *  derive it from `next_event`, which is the normal state. */
  strip_message: string | null;
  /** Optional replacement for the strip's built-in "All announcements →"
   *  link. The backend guarantees both are set or neither is. */
  strip_cta_label: string | null;
  strip_cta_url: string | null;
  events: ExamEvent[];
  countdown_date: string | null;
  days_to_exam: number | null;
  next_event: ExamEvent | null;
}

export const examKey = ["exam", "current"] as const;

/** Null data when no cycle is configured — the countdown is decoration and
 *  its absence must never break a page. */
export const getCurrentExamCycle = async (): Promise<
  ApiResponse<ExamCycle | null>
> => {
  const res = await axiosInstance.get("/exam/current");
  return res.data;
};
